import { init, track } from "@plausible-analytics/tracker";
// src/telemetry/effects.ts
let isTrackingEnabled = false;
const configurePlausible = ({ enabled, ...config }) => {
	if (enabled) {
		init({
			...config,
			outboundLinks: true,
			fileDownloads: true
		});
		isTrackingEnabled = true;
	}
};
const trackEvent = (name, options = {}) => {
	if (isTrackingEnabled) track(name, options);
};
export { configurePlausible, trackEvent };

//# sourceMappingURL=effects.js.map